import { createFileRoute } from '@tanstack/react-router';

import { conciliationNewScreen, loadConciliationMessages, loadConciliationScreens, newConciliationSearch } from '@/modules/conciliation/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/gestao-carteira/conciliacao/dataprev/nova-conciliacao')({
  validateSearch: newConciliationSearch,
  staticData: { screen: conciliationNewScreen },
  loader: () => loadConciliationMessages(),
  component: lazyScreen(loadConciliationScreens, 'ConciliationNewRouteScreen'),
});
